import jwtInterceptor from '@/plugins/jwtInterceptor';
import type { EffectivePermissions } from '@/types/permissions';

/**
 * Fetches the effective permissions for the currently authenticated user.
 *
 * Returns both the permissions payload and the Mercure subscriber token/topic
 * headers (if present) so the caller can set up an SSE subscription.
 *
 * DEVAMS-2014: The /me/permissions endpoint is added in DEVAMS-2013 (S2).
 */
export async function fetchEffectivePermissions(): Promise<{
  data: EffectivePermissions;
  mercureToken: string | null;
  mercureTopic: string | null;
}> {
  const response = await jwtInterceptor.get<EffectivePermissions>('v1/me/permissions');

  const mercureToken = (response.headers?.['x-mercure-token'] as string | undefined) ?? null;
  const mercureTopic = (response.headers?.['x-mercure-topic'] as string | undefined) ?? null;

  return {
    data: response.data,
    mercureToken,
    mercureTopic,
  };
}
